import { productIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { restrictionTier } from "./restriction-tier-output";

export const productRestrictionOutput = z.object({
  destinationCountryCode: z.string(),
  tier: restrictionTier,
  category: z.string().nullable(),
  matchHsCode: z.string(),
  confidenceScore: z.number().nullable(),
  summary: z.string(),
  sourceUrl: z.string().nullable(),
  lastSeenAt: z.date(),
});

export const getProductRestrictions = {
  name: "getProductRestrictions" as const,
  input: z.object({ productId: productIdFormat.schema }),
  output: z.object({
    restrictions: z.array(productRestrictionOutput),
    lanes: z.array(
      z.object({
        destinationCountryCode: z.string(),
        lastScreenedAt: z.date().nullable(),
      }),
    ),
  }),
};
